<template>
  <button class="btn btn-default btn-xs filter-clear pull-right"
    v-show="hasFilters"
    @click.prevent="clearFilters"
  >
    <i class="fa fa-close"></i>
  </button>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
      required: true
    },

    filters: {
      type: Object,
      required: true
    },

    names: {
      required: true
    }
  },

  computed: {
    namesArray() {
      if(_.isArray(this.names)) {
        return this.names
      }

      return _.compact(
        this.names
          .replace(/\s/g,'')
          .split(',')
      )
    },

    hasFilters() {
      let hasFilters = false

      this.namesArray.forEach(function(name) {
        if(name in this.filters && this.filters[name]) {
          hasFilters = true
        }
      }.bind(this))

      return hasFilters
    },
  },

  methods: {
    clearFilters(event) {
      this.callback(this.namesArray)
    },
  }
}
</script>
